import { setChatListFailed, setChatListPending, setChatListSucceed } from './actions';
import { IChatListRequest } from './types';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { fetchChatsV2, IFetchChatsV2ParamsRequest } from '../../services/chatsList/fetchChatsV2';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { getQueryParamsFetchChatsList } from '../../utils/getQueryParamsFetchChatsList';
import { setErrorPage } from '../errorPage';
// eslint-disable-next-line import/no-cycle
import { setRoute } from '../route';

/**
 * Получить список чатов
 */
export const getChatsV2 =
  ({ notClearCurrentOpenedChatId, timestamp }: IChatListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const {
      chatList,
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setChatListPending({ notClearCurrentOpenedChatId, timestamp }));

    const { status, filterBy } = getQueryParamsFetchChatsList(ERoute.Messages);

    const parameters: IFetchChatsV2ParamsRequest = {
      timestamp,
      subAgentRealtyUserId,
      status,
      filterBy,
    };

    const chats = await fetchChatsV2(context, {
      parameters,
    });

    if (chats !== null) {
      dispatch(setChatListSucceed({ chats, isV2Version: true }));

      /**
       * Ставим активный пункт меню - сообщения
       */
      if (chatList.currentRoute !== ERoute.Messages) {
        dispatch(setRoute({ route: ERoute.Messages }));
      }
    } else {
      if (chatList.isFirstLoad) {
        dispatch(setErrorPage());
      }

      dispatch(setChatListFailed());
    }
  };
